import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function WhatYouGetSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-24 px-6" style={{
    background: '#111827'
  }} data-id="element-264">
      <div className="max-w-4xl mx-auto" data-id="element-265">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-266">
          <div className="amber-divider mb-8" data-id="element-267" />
          <p className="text-center text-sm uppercase tracking-widest mb-4" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#D4A853'
        }} data-id="element-268">
            Votre kit complet
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-269">
            Ce que vous recevez
          </h2>
          <p className="text-center mb-12" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#8A8070'
        }} data-id="element-270">
            Tout ce dont vous avez besoin pour reprendre le contrôle de vos
            nuits, dès ce soir.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-271">
            {/* Item 1 */}
            <div className="rounded-2xl p-6 flex gap-4" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-272">
              <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg" style={{
              background: 'rgba(212,168,83,0.15)',
              color: '#D4A853'
            }} data-id="element-273">
                ✓
              </div>
              <div data-id="element-274">
                <h3 className="text-base font-semibold mb-1" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-275">
                  Le Guide PDF
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-276">
                  <em style={{
                  color: '#D4A853'
                }} data-id="element-277">
                    "10 minutes pour éteindre le cerveau"
                  </em>{' '}
                  — La méthode pas à pas, claire et actionnable.
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="rounded-2xl p-6 flex gap-4" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-278">
              <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg" style={{
              background: 'rgba(212,168,83,0.15)',
              color: '#D4A853'
            }} data-id="element-279">
                ✓
              </div>
              <div data-id="element-280">
                <h3 className="text-base font-semibold mb-1" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-281">
                  Le Protocole du Reset Somatique
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-282">
                  3 exercices de 60 secondes pour calmer le cœur instantanément.
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="rounded-2xl p-6 flex gap-4" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-283">
              <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg" style={{
              background: 'rgba(212,168,83,0.15)',
              color: '#D4A853'
            }} data-id="element-284">
                ✓
              </div>
              <div data-id="element-285">
                <h3 className="text-base font-semibold mb-1" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-286">
                  La Décharge Mentale Stratégique
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-287">
                  Le système de journaling en 3 colonnes pour "déposer" ses
                  peurs sur papier et vider la boucle de rumination.
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="rounded-2xl p-6 flex gap-4" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-288">
              <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg" style={{
              background: 'rgba(212,168,83,0.15)',
              color: '#D4A853'
            }} data-id="element-289">
                ✓
              </div>
              <div data-id="element-290">
                <h3 className="text-base font-semibold mb-1" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-291">
                  La Checklist de la Table de Nuit
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-292">
                  Pour ne plus jamais hésiter sur quoi faire lors d'un réveil à
                  3h du matin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}